import { Grid } from "@mui/material";
import { FC } from "react";
import {
  CreditosOrganizacion,
  CreditosSuborganizacion,
  CreditosSuscripcion,
  CreditosUsario,
} from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import CustomInfoBox from "../CustomInfoBox";

interface Props {
  credits:
    | CreditosOrganizacion
    | CreditosSuborganizacion
    | CreditosUsario
    | CreditosSuscripcion;
}

const SingleEntityInfoBoxes: FC<Props> = ({ credits }) => {
  return (
    <Grid container spacing={2} sx={{ color: "#336B87", minHeight: "240px" }}>
      {/* Créditos totales */}
      <Grid item xs={12} sm={6} md={3}>
        <CustomInfoBox
          value={credits?.creditos_totales}
          title="Créditos totales"
        />
      </Grid>

      {/* Créditos disponibles */}
      <Grid item xs={12} sm={6} md={3}>
        <CustomInfoBox
          value={credits?.creditos_disponibles}
          title="Créditos disponibles"
        />
      </Grid>

      {/* Créditos gastados */}
      <Grid item xs={12} sm={6} md={3}>
        <CustomInfoBox
          value={credits?.creditos_gastados}
          title="Créditos gastados"
        />
      </Grid>

      {/* Créditos desperdiciados */}
      <Grid item xs={12} sm={6} md={3}>
        <CustomInfoBox
          value={credits?.creditos_desperdiciados}
          title="Créditos desperdiciados"
        />
      </Grid>
    </Grid>
  );
};

export default SingleEntityInfoBoxes;
